import { render, staticRenderFns } from "./OutsourcProcessInHistory.vue?vue&type=template&id=79af4aa0&scoped=true&"
import script from "./OutsourcProcessInHistory.vue?vue&type=script&lang=js&"
export * from "./OutsourcProcessInHistory.vue?vue&type=script&lang=js&"
import style0 from "./OutsourcProcessInHistory.vue?vue&type=style&index=0&id=79af4aa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79af4aa0",
  null
  
)

export default component.exports